import { Component, OnInit, afterNextRender } from '@angular/core';
import { FeriasBaseComponent } from '../../ferias-base.component';
import { CancelamentoParcelaInterrompidaFerias, ExercicioSelecionado, ExerciciosService, ParcelaFerias } from 'src/app/services/exercicios.service';
import { AlertMessageService } from '@sigepe/sigepe-template';
import { ConfirmationService, MenuItem as MenuItem_PrimeNG } from 'primeng/api';
import { DataFormatadaPipe } from 'src/app/components/shared/pipes/dataFormatada.pipe';
import { Router } from '@angular/router';
import { getDateFromYYYYMMDD } from 'src/app/components/shared/date-utils';
import { SituacaoParcelaFeriasEnum } from 'src/app/components/shared/enums/situacao-parcela-ferias.enum';
import { Message } from 'src/app/components/shared/message';

export interface ParcelaFeriasParaCancelarInterrupcao {
    id: number;
    idParcelaPai?: number;
    ordem: number;
    geracao: number;
    dataInicio: Date;
    dataFim: Date;
    quantidadeDias: number;
    situacao: {
        //Vindo da enum SituacaoParcelaFeriasEnum
        descricao: string;
        codigoCor: string;
    };
    adiantamentoSalarial: {
        valor: boolean;
    };
    abonoPecuniario: {
        valor: boolean;
    };
    adiantamentoDecimoTerceiro: {
        valor: boolean;
    };
    parcelasDesconto: number;
    podeCancelarInterrupcao: boolean;
    selecionadaParaCancelarInterrupcao: boolean;
    dataInterrupcao: Date;
    motivoLegal: string;
    justificativaInterrupcao: string;
    justificativaCancelamentoInterrupcao: string;
    documentoLegal: string;
    dataPublicacaoDocumentoLegal: Date;
    validacao: {
        justificativaCancelamentoInterrupcaoInvalida: boolean;
    };
    dataInicioOriginal?: Date;
    dataFimOriginal?: Date;
    quantidadeDiasOriginal?: number;
}

@Component({
    selector: 'app-cancelar-interrupcao',
    templateUrl: './cancelar-interrupcao.component.html',
    styleUrls: ['./cancelar-interrupcao.component.scss']
})
export class CancelarInterrupcaoComponent extends FeriasBaseComponent implements OnInit {
    submetido = false;
    houvePreenchimento = false;

    exercicioSelecionado: ExercicioSelecionado;

    parcelasFeriasParaCancelarInterrupcao: ParcelaFeriasParaCancelarInterrupcao[];

    constructor(
        private exerciciosService: ExerciciosService,
        alertaMsgService: AlertMessageService,
        private confirmationService: ConfirmationService,
        private dataFormatadaPipe: DataFormatadaPipe,
        private router: Router
    ) {
        super(alertaMsgService);

        this.exercicioSelecionado = this.router.getCurrentNavigation().extras.state.data;

        afterNextRender(() => {
            this.alterarTituloTemplate('Gerenciar Férias');
            this.alterarTextoBreadcrumb(1, 'Gerenciar Férias - Buscar Agente Público');
            this.rolarParaTopo();
        });
    }

    ngOnInit(): void {
        this.parcelasFeriasParaCancelarInterrupcao = [];
        this.exercicioSelecionado.parcelas.forEach(parcelaFerias => {
            if (parcelaFerias.ordem !== 99) {
                //Ignorar parcelas Canceladas
                this.parcelasFeriasParaCancelarInterrupcao.push(this.resgatarParcelaInterrompida(parcelaFerias, 0));
            }
        });
    }

    get msgJustificativaInvalida(): string {
        return Message.ERRO_JUSTIFICATIVA_TAMANHO_INVALIDO;
    }

    get msgJustificativaObrigatoria(): string {
        return Message.ERRO_JUSTIFICATIVA_OBRIGATORIA;
    }

    get msgParcelaPrecisaSerSelecionada(): string {
        return 'Para concluir, é necessário selecionar ao menos uma parcela para interrupção.';
    }

    get msgCamposObrigatoriosNaoPreenchidos(): string {
        return Message.ERRO_CAMPOS_OBRIGATORIOS_NAO_PREENCHIDOS;
    }

    resgatarParcelaInterrompida(parcelaFerias: any, profundidade: number): ParcelaFeriasParaCancelarInterrupcao {
        if (!parcelaFerias.parcelaFilha || SituacaoParcelaFeriasEnum.fromDesc(parcelaFerias.parcelaFilha.situacao).descricao !== SituacaoParcelaFeriasEnum.INTERROMPIDA.descricao) {
            return {
                id: parcelaFerias.id,
                idParcelaPai: parcelaFerias.idParcelaPai,
                ordem: parcelaFerias.ordem,
                geracao: profundidade,
                dataInicio: getDateFromYYYYMMDD(parcelaFerias.dataInicio),
                dataFim: getDateFromYYYYMMDD(parcelaFerias.dataFim),
                quantidadeDias: parcelaFerias.quantidadeDias,
                situacao: {
                    descricao: SituacaoParcelaFeriasEnum.fromDesc(parcelaFerias.situacao).descricao,
                    codigoCor: SituacaoParcelaFeriasEnum.fromDesc(parcelaFerias.situacao).extras.codigoCor
                },
                adiantamentoSalarial: {
                    valor: parcelaFerias.adiantamentoSalarial
                },
                abonoPecuniario: {
                    valor: parcelaFerias.abonoPecuniario
                },
                adiantamentoDecimoTerceiro: {
                    valor: parcelaFerias.adiantamentoDecimoTerceiro
                },
                parcelasDesconto: parcelaFerias.parcelasDesconto,
                podeCancelarInterrupcao: SituacaoParcelaFeriasEnum.fromDesc(parcelaFerias.situacao).descricao === SituacaoParcelaFeriasEnum.INTERROMPIDA.descricao,
                selecionadaParaCancelarInterrupcao: false,
                motivoLegal: parcelaFerias.motivoLegal,
                justificativaInterrupcao: parcelaFerias.justificativaInterrupcao,
                justificativaCancelamentoInterrupcao: '',
                dataInterrupcao: parcelaFerias.dataInterrupcao,
                documentoLegal: parcelaFerias.documentoLegal,
                dataPublicacaoDocumentoLegal: parcelaFerias.dataPublicacaoDocumentoLegal,
                validacao: {
                    justificativaCancelamentoInterrupcaoInvalida: false
                },
                dataInicioOriginal: parcelaFerias.dataInicioOriginal,
                dataFimOriginal: parcelaFerias.dataFimOriginal,
                quantidadeDiasOriginal: parcelaFerias.quantidadeDiasOriginal
            };
        } else {
            return this.resgatarParcelaInterrompida(parcelaFerias.parcelaFilha, profundidade + 1);
        }
    }

    desistirSelecaoParcelaParaCancelarInterrupcao(parcela: ParcelaFeriasParaCancelarInterrupcao) {
        parcela.justificativaCancelamentoInterrupcao = '';
        parcela.selecionadaParaCancelarInterrupcao = false;
        parcela.validacao.justificativaCancelamentoInterrupcaoInvalida = false;
    }

    selecionarParcelaParaCancelarInterrupcao(parcela: ParcelaFeriasParaCancelarInterrupcao) {
        this.houvePreenchimento = true;
        parcela.selecionadaParaCancelarInterrupcao = true;
    }

    validarJustificativaCancelamentoInterrupcao(parcela: ParcelaFeriasParaCancelarInterrupcao) {
        if (parcela.justificativaCancelamentoInterrupcao && (parcela.justificativaCancelamentoInterrupcao.trim().length < 10 || parcela.justificativaCancelamentoInterrupcao.trim().length > 300)) {
            parcela.validacao.justificativaCancelamentoInterrupcaoInvalida = true;
        } else {
            parcela.validacao.justificativaCancelamentoInterrupcaoInvalida = false;
        }
    }

    existeJustificativaInvalida(): boolean {
        return this.parcelasFeriasParaCancelarInterrupcao.some(parcela => {
            return parcela.validacao.justificativaCancelamentoInterrupcaoInvalida;
        });
    }

    existeParcelaSelecionada(): boolean {
        return this.parcelasFeriasParaCancelarInterrupcao.some(parcela => parcela.selecionadaParaCancelarInterrupcao);
    }

    existeCampoObrigatorioNaoInformado(): boolean {
        return this.parcelasFeriasParaCancelarInterrupcao.some(parcela => {
            return parcela.selecionadaParaCancelarInterrupcao && (!parcela.justificativaCancelamentoInterrupcao || parcela.justificativaCancelamentoInterrupcao.trim().length === 0);
        });
    }

    onJustificativaCancelamentoInterrupcaoChange(event, parcela: ParcelaFeriasParaCancelarInterrupcao) {
        parcela.justificativaCancelamentoInterrupcao = event.target.value ? event.target.value.trim() : '';
    }

    confirmarVoltar() {
        if (this.houvePreenchimento) {
            this.confirmationService.confirm({
                key: 'confirmPadrao',
                header: 'Confirmação',
                message: Message.CONFIRMACAO_ABANDONAR_TELA_COM_PERDA_DE_DADOS,
                accept: async () => {
                    this.voltar();
                }
            });
        } else {
            this.voltar();
        }
    }

    voltar(): void {
        this.router.navigate(['/secure/gerenciar-ferias/consultar-exercicios']);
    }

    confirmarCancelamentoInterrupcao() {
        this.submetido = true;
        this.clearMessages();

        let podeCancelarInterrupcao = true;

        if (!this.existeParcelaSelecionada()) {
            this.getAlertaMsgService().error(this.msgParcelaPrecisaSerSelecionada);
            podeCancelarInterrupcao = false;
        }

        if (this.existeCampoObrigatorioNaoInformado()) {
            this.getAlertaMsgService().error(this.msgCamposObrigatoriosNaoPreenchidos);
            podeCancelarInterrupcao = false;
        }

        // Validação da justificativa
        this.parcelasFeriasParaCancelarInterrupcao.forEach(parcela => {
            this.validarJustificativaCancelamentoInterrupcao(parcela);
        });
        if (this.existeJustificativaInvalida()) {
            this.getAlertaMsgService().error(this.msgJustificativaObrigatoria);
            podeCancelarInterrupcao = false;
        }

        if (podeCancelarInterrupcao) {
            const parcelasParaCancelarInterrupcao = this.parcelasFeriasParaCancelarInterrupcao.filter(parcela => parcela.selecionadaParaCancelarInterrupcao);

            let mensagem;
            if (parcelasParaCancelarInterrupcao.length > 1) {
                mensagem = 'Tem certeza que deseja cancelar a interrupção das parcelas ';
                parcelasParaCancelarInterrupcao.forEach((parcelaParaCancelarInterrupcao, index) => {
                    const ultimoItem = index === parcelasParaCancelarInterrupcao.length - 1;

                    if (ultimoItem) {
                        mensagem += ' e ' + parcelaParaCancelarInterrupcao.ordem + (parcelaParaCancelarInterrupcao.geracao ? '.' + parcelaParaCancelarInterrupcao.geracao : '');
                    } else {
                        if (index > 0) {
                            mensagem += ', ';
                        }
                        mensagem += parcelaParaCancelarInterrupcao.ordem + (parcelaParaCancelarInterrupcao.geracao ? '.' + parcelaParaCancelarInterrupcao.geracao : '');
                    }
                });
                mensagem += ' do exercício de ' + this.exercicioSelecionado.anoExercicio + '?';
            } else {
                mensagem = 'Tem certeza que deseja cancelar a interrupção da parcela ' + parcelasParaCancelarInterrupcao[0].ordem + (parcelasParaCancelarInterrupcao[0].geracao ? '.' + parcelasParaCancelarInterrupcao[0].geracao : '') + ' do exercício de ' + this.exercicioSelecionado.anoExercicio + '?';
            }

            this.confirmationService.confirm({
                key: 'confirmPadrao',
                header: 'Confirmação',
                message: mensagem,
                accept: async () => {
                    this.cancelarInterrupcao();
                }
            });
        }
    }

    cancelarInterrupcao() {
        const parcelasFerias: any[] = this.gerarParcelasFeriasAgregadas();

        const cancelarInterrupcaoFerias: any = {
            parcelas: parcelasFerias
        };

        this.exerciciosService.cancelarInterrupcaoFerias(this.exercicioSelecionado.idFerias, cancelarInterrupcaoFerias).subscribe(data => {
            if (data.sucessoEnvioMensageria) {
                this.getAlertaMsgService().setAwatingSuccessMessage(Message.CANCELAMENTO_COM_SUCESSO);
            } else {
                this.getAlertaMsgService().setAwatingWarnMessage(Message.AVISO_ACAO_REALIZADA_SEM_NOTIFICACAO_AUTOMATICA);
            }

            this.voltar();
        });
    }

    gerarParcelasFeriasAgregadas(): any[] {
        //Essa função é recursiva
        const gerarParcelasExercicioAtual: Function = (parcelaFerias: any[], profundidade = 0, idParcelaPai?: number): any[] => {
            let parcelasAgregadas: any[] = [];

            //Adiciona as parcelas do exercicio de férias atual
            parcelaFerias.forEach(parcelaFerias => {
                const parcelaCancelada = this.parcelasFeriasParaCancelarInterrupcao.find(p => p.id === parcelaFerias.id && p.selecionadaParaCancelarInterrupcao);

                if (parcelaCancelada) {
                    parcelasAgregadas.push({
                        id: parcelaCancelada.id,
                        idParcelaPai: idParcelaPai,
                        ordem: parcelaCancelada.ordem,
                        dataInicio: parcelaCancelada.dataInicio,
                        quantidadeDias: parcelaCancelada.quantidadeDias,
                        adiantamentoSalarial: undefined,
                        abonoPecuniario: undefined,
                        adiantamentoDecimoTerceiro: undefined,
                        justificativaCancelamentoInterrupcao: parcelaCancelada.justificativaCancelamentoInterrupcao,
                        dataFim: parcelaCancelada.dataFim,
                        situacao: undefined,
                        motivoLegal: parcelaCancelada.motivoLegal,
                        dataInterrupcao: parcelaCancelada.dataInterrupcao,
                        justificativaInterrupcao: parcelaCancelada.justificativaInterrupcao,
                        documentoLegal: parcelaCancelada.documentoLegal,
                        dataPublicacaoDocumentoLegal: parcelaCancelada.dataPublicacaoDocumentoLegal
                    });
                } else {
                    parcelasAgregadas.push({
                        id: parcelaFerias.id,
                        idParcelaPai: idParcelaPai,
                        ordem: parcelaFerias.ordem,
                        dataInicio: getDateFromYYYYMMDD(parcelaFerias.dataInicio),
                        quantidadeDias: parcelaFerias.quantidadeDias,
                        adiantamentoSalarial: parcelaFerias.adiantamentoSalarial,
                        abonoPecuniario: parcelaFerias.abonoPecuniario,
                        adiantamentoDecimoTerceiro: parcelaFerias.adiantamentoDecimoTerceiro,
                        justificativaCancelamentoInterrupcao: parcelaFerias.justificativaCancelamentoInterrupcao,
                        dataFim: getDateFromYYYYMMDD(parcelaFerias.dataFim),
                        situacao: parcelaFerias.situacao,
                        motivoLegal: parcelaFerias.motivoLegal,
                        dataInterrupcao: parcelaFerias.dataInterrupcao,
                        justificativaInterrupcao: parcelaFerias.justificativaInterrupcao,
                        documentoLegal: parcelaFerias.documentoLegal,
                        dataPublicacaoDocumentoLegal: parcelaFerias.dataPublicacaoDocumentoLegal
                    });

                    if (parcelaFerias.parcelaFilha) {
                        parcelasAgregadas = parcelasAgregadas.concat(gerarParcelasExercicioAtual([parcelaFerias.parcelaFilha], profundidade + 1, parcelaFerias.id));
                    }
                }
            });

            return parcelasAgregadas;
        };

        const parcelasFeriasAgregadas: any[] = gerarParcelasExercicioAtual(this.exercicioSelecionado.parcelas);

        //Ordena as parcelas
        parcelasFeriasAgregadas.sort((a, b) => a.ordem - b.ordem);

        return parcelasFeriasAgregadas;
    }
}
